<mat-dialog-content>
  <p style="font-weight: 400; opacity: 0.9">
    Lo sentimos, sólo se puede acceder a noticias con un máximo de 30 días de antiguedad
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Aceptar</button>
</mat-dialog-actions>
